import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Troll Tokens · Your Gateway to Crypto</p>
        <h1>Trade and Learn Cryptocurrency with Confidence</h1>
        <p className="lede">
          Discover the world of cryptocurrency trading and education. At Troll Tokens, we empower you with the knowledge and tools to navigate the crypto market effectively.
        </p>
        <div className="cta-row">
          <a href="/trade" target="_blank">
            Start Trading
          </a>
          <a href="/learn" target="_blank" className="secondary">
            Explore Education Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Trade with Ease</h2>
          <p>
            Join our platform to buy, sell, and trade a variety of cryptocurrency tokens seamlessly and securely.
          </p>
        </article>
        <article>
          <h2>Learn the Basics</h2>
          <p>
            Access comprehensive educational resources designed for beginners and seasoned traders alike to enhance your understanding of the crypto landscape.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Keep up with the latest market trends and insights to make informed trading decisions and maximize your potential.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;